import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';

Chart.register(zoomPlugin);

const verticalLinePlugin = {
    id: 'verticalLine',
    afterDraw: function (chart, args, options) {

        let display = options.display || true;

        if (!options.display)
        {
            return;
        }

        const chartArea = chart.chartArea;
        const ctx = chart.ctx;
        const yAxis = chart.scales.y;

        // Determine the x-axis value for the current day, hour or month
        const xAxis = chart.scales.x;
        let linePosition;
        switch (options.timeUnit) {
            case 'day':
                linePosition = xAxis.getPixelForValue(new Date().setHours(0, 0, 0, 0));
                break;
            case 'hour':
                linePosition = xAxis.getPixelForValue(new Date().setMinutes(0, 0, 0));
                break;
            case 'month':
                linePosition = xAxis.getPixelForValue(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
                break;
            default:
                return;
        }

        // Draw the vertical line
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(linePosition, chartArea.top);
        ctx.lineTo(linePosition, chartArea.bottom);
        ctx.lineWidth = options.lineWidth || 2;
        ctx.strokeStyle = options.lineColor || 'rgba(255, 0, 0, 0.5)';
        ctx.stroke();
        ctx.restore();
    },
};

const tooltipLineOnHoverPlugin = {
    id: 'tooltipLineOnHover',
    afterDraw: function (chart, args, options) {

        let display = options.display || true;

        if (!options.display)
        {
            return;
        }

        const chartArea = chart.chartArea;

        const ctx = chart.ctx;
        const yAxis = chart.scales.y;
        let strokeColor = options.lineColor || '#ff0000';
        let lineWidth = options.lineWidth || 1;

        if (chart.tooltip?._active?.length) {
            let x = chart.tooltip._active[0].element.x;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, yAxis.top);
            ctx.lineTo(x, yAxis.bottom);
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = strokeColor;
            ctx.stroke();
            ctx.restore();
        }
    },
};

Chart.register(verticalLinePlugin);
Chart.register(tooltipLineOnHoverPlugin);

const ChartWrapper = (function () {
    function createChart(ctx, config) {
        return new Chart(ctx, config);
    }

    function updateConfig(chartInstance, newConfig) {
        /*
        if (newConfig.options) {
            chartInstance.options = Object.assign(chartInstance.options, newConfig.options);
        }

        if (newConfig.data) {
            if (newConfig.data.labels) {
                chartInstance.data.labels = newConfig.data.labels;
            }

            if (newConfig.data.datasets) {
                chartInstance.data.datasets = newConfig.data.datasets;
            }
        }

         */

        chartInstance.config._config = newConfig;
        chartInstance.update();
    }

    return {
        create: function (ctx, config) {
            return createChart(ctx, config);
        },
        update: function (chartInstance, newConfig) {
            updateConfig(chartInstance, newConfig);
        }
    };
})();

window.ChartWrapper = ChartWrapper;
